import * as angular from 'angular';
import {IController} from 'angular';
import * as _ from "lodash";

export class BringozAdditionsComponent implements IController {

  additions: any;
  maxAdditions: any;

  private viewAdditions: any;
  private extraAdditionsCount: any;
  private extraAdditions: any;

  constructor() {
  }

  $onInit() {
    this.viewAdditions = [];

    this.initAdditions(this.additions);
  }

  $onChanges(changes) {
    if (changes.tags && !changes.tags.isFirstChange()) {
      this.initAdditions(this.additions);
    }
  };

  private initAdditions(additions) {
    this.extraAdditionsCount = undefined;

    if (_.get(additions, 'length')) {
      this.viewAdditions = this.maxAdditions ? _.filter(additions, (item, index) => {
        return index + 1 <= this.maxAdditions;
      }) : additions;

      if (additions.length > this.viewAdditions.length) {
        this.extraAdditionsCount = '+' + (additions.length - this.viewAdditions.length).toString();
      }

      if (this.extraAdditionsCount) {
        const podsCopy = angular.copy(this.additions);
        this.extraAdditions = podsCopy.slice(this.viewAdditions.length);
      }

    }
  }

}


angular
  .module('bringoz.admin.commons')
  .component('bringozAdditions', {
    bindings: {
      additions: '<',
      maxAdditions: '<?'
    },
    template: require('./bringoz-additions.html').default,
    controller: BringozAdditionsComponent
  });

